{
  "clusterServices": "Mine tjenester",
  "allServices": "Alle tjenester",
  "serviceCatalog": "Tjenestekatalog",
  "activeServices": "Aktive tjenester",
  "inactiveServices": "Inaktive tjenester",
  "addService": "Legg til tjeneste",
  "editService": "Endre tjeneste",
  "notification.text": "Denne knappen tar deg til Felles tjenestekatalog. Du vil snart få muligheten til å legge til tjenester inne i Flerbedriftsportalen.",
  "details.header": "Om tjenesten",
  "details.validFrom": "Tjenesten er gyldig fra",
  "details.validTo": "Tjenesten er gyldig til",
  "details.description": "Beskrivelse av tjenesten",
  "details.customerDescription": "Beskrivelse av tjenesten for kunde",
  "details.purpose": "Formål med tjenesten",
  "details.links": "Lenker",
  "details.targetAudience": "Målgruppe",
  "details.companyAge": "Krav til alder på bedrift",
  "details.companySize": "Krav til bedriftstørrelse",
  "details.customerSegment": "Relevant for utvalgte kundesegment",
  "details.customerSegmentComment": "Kommentar til kundesegment",
  "details.delivery": "Leveranse",
  "details.deliveryType": "Leveransetype",
  "details.deliveryDescription": "Hvordan tjenesten leveres",
  "details.deadline": "Søknadsfrist",
  "details.userFee": "Brukerbetaling",
  "details.userFeeComment": "Kommentar til brukerbetaling",
  "details.contact": "Leverandør og kontaktinfo",
  "details.origin": "Leverandør",
  "details.contract": "Oppdragsgiver",
  "details.EEA": "EØS-artikler",
  "details.EEAarticles": "EØS-artikler som anvendes",
  "details.Error": "Kunne ikke hente tjeneste. Prøv igjen eller kontakt support.",

  "form.edit": "Rediger tjeneste",
  "form.publish": "Publiser",
  "form.publishChanges": "Publiser endringer",
  "form.saveAsDraft": "Lagre og lukk",
  "form.deleteDraft": "Slett utkast",
  "form.next": "Neste",
  "form.back": "Forrige",
  "form.add": "Legg til",
  "form.edit.button": "Rediger",
  "form.yes": "Ja",
  "form.no": "Nei",

  "about.title": "Om tjenesten",
  "about.serviceName.label": "Hva er navnet på tjenesten?",
  "about.serviceName.help": "Angi det norske navnet på tjenesten slik det brukes i kundedialog og på nettsiden.",
  "about.serviceName.required": "Vennligst skriv navnet på tjenesten",
  "about.serviceName.maxLength": "Tjenestenavnet kan maksimalt være 500 tegn",
  "about.validFrom.label": "Tjenesten er gyldig fra",
  "about.validFrom.required": "Vennligst angi dato tjenesten er gyldig fra",
  "about.validTo.label": "Tjenesten er gyldig til",
  "about.validTo.required": "Vennligst angi dato tjenesten er gyldig til",
  "about.validTo.beforeValidFrom": "Gyldig til-datoen kan ikke være før gyldig fra-datoen",
  "about.description.label": "Hvordan vil du beskrive tjenesten?",
  "about.description.help": "Beskriv kort innholdet i tjenesten som om du forklarer det til noen som ikke har hørt om den før.",
  "about.description.required": "Vennligst beskriv innholdet i tjenesten",
  "about.purpose.label": "Hva er formålet med tjenesten?",
  "about.purpose.help": "Beskriv kort hvorfor denne tjenesten tilbys. Forklar hvilken effekt tjenesten skal gi for samfunnet/næringslivet. Er det konkrete effekter som oppdragsgiver vil oppnå? Hva gjør tjenesten viktig for samfunnet?",
  "about.purpose.required": "Vennligst beskriv formålet med tjenesten",
  "about.purpose.maxLength": "Formålet kan maksimalt være 500 tegn",
  "about.keywords.label": "Hvilke nøkkelord er relevante for tjenesten? (Legg til ett og ett ord)",
  "about.keywords.help": "Skriv nøkkelord som ofte brukes når denne tjenesten er relevant. Disse ordene brukes i søk og algoritmer.",
  "about.keywords.required": "Vennligst legg til nøkkelord",
  "about.links.title": "Hvilke lenker er relevante for tjenesten?",
  "about.links.help": "Legg inn lenker som er spesielt relevante for rådgivere eller kunder.",
  "about.links.text": "Tekst som vises",
  "about.links.url": "Skriv inn URL",
  "about.customerDescription.label": "Hvordan vil du beskrive tjenesten som et innsalg til kunde i e-post?",
  "about.customerDescription.help": "Beskriv tjenesten for kunde. Beskrivelsen brukes i e-poster til kunde når de får anbefalt tjenesten.",

  "target.title": "Målgruppe og geografisk nedslagsfelt",
  "target.companyAge.label": "Er det krav til bedriftens alder?",
  "target.companyAge.help": "Velg krav til bedriftens alder.",
  "target.companyAge.required": "Vennligst velg et alternativ",
  "target.companySize.label": "Er det krav til bedriftsstørrelse?",
  "target.companySize.help": "Velg krav til bedriftens størrelse.",
  "target.companySize.required": "Vennligst velg ett eller flere alternativer",
  "target.innovationLevelCriteria.placeholder": "Velg nivå",
  "target.innovationLevelCriteria.label": "Har tjenesten krav til bedriftens innovasjonsnivå?",
  "target.innovationLevelCriteria.help": "Velg krav til bedriftens innovasjonsnivå.",
  "target.innovationLevelCriteria.required": "Vennligst velg innovasjonsnivå",
  "target.innovationLevelCriteria.title": "Innovasjonsnivå",
  "target.innovationLevelCriteria.CompanyLevel": "Bedriftsnivå",
  "target.innovationLevelCriteria.RegionalLevel": "Regionalt nivå",
  "target.innovationLevelCriteria.NationalLevel": "Nasjonalt nivå",
  "target.innovationLevelCriteria.InternationalLevel": "Internasjonalt nivå",
  "target.innovationLevelCriteria.NotRelevant": "Ikke relevant",
  "target.innovationLevelCriteria.Unknown": "Ukjent",
  "target.customerSegment.label": "Er tjenesten kun relevant for utvalgte kundesegment?",
  "target.customerSegment.help": "Velg relevante kundesegmenter.",
  "target.customerSegment.required": "Vennligst velg ett eller flere alternativer",
  "target.customerSegment.addComment": "Legg til kommentar",
  "target.customerSegment.comment.label": "Kommentar til kundesegment",
  "target.customerSegment.comment.help": "Utdyp her hvis tjenesten retter seg mot sektorspesifikke næringer.",
  "target.districtPolicy.label": "Må aktiviteten gjennomføres innenfor distriktspolitisk virkeområde?",
  "target.districtPolicy.help": "Er tjenesten kun relevant for prosjekter innen distriktspolitisk virkeområde (DVP)? Velg Ja eller Nei.",
  "target.districtPolicy.required": "Vennligst velg et alternativ",
  "target.geographic.label": "For hvilket område gjelder tjenesten?",
  "target.geographic.help": "Velg alle fylker/kommuner der du leverer denne tjenesten.",
  "target.geographic.dialogTitle": "Legg til geografisk nedslagsfelt",
  "target.geographic.required": "Vennligst legg til minst ett fylke eller en kommune",

  "delivery.title": "Leveranse",
  "delivery.type.label": "Hva er primær leveransetype for tjenesten?",
  "delivery.type.help": "Angi primær leveransetype/leveranseform for tjenesten. Velg en eller flere.",
  "delivery.type.required": "Vennligst velg ett eller flere alternativer",
  "delivery.description.label": "Hvordan leveres tjenesten?",
  "delivery.description.help": "Beskriv hvordan tjenesten leveres. Leveres tjenesten f.eks via spesifikke aktører eller assosierte konsulenter kan dettte presiseres her.",
  "delivery.description.required": "Vennligst beskriv hvordan tjenesten leveres",
  "delivery.deadline.question": "Leveres tjenesten gjennom utlysning med søknadsfrist?",
  "delivery.deadline.help": "Leveres tjenesten gjennom utlysning med søknadsfrist? Velg ja/nei.",
  "delivery.deadline.question.required": "Vennligst velg et alternativ",
  "delivery.deadline.label": "Hva er søknadsfristen?",
  "delivery.deadline.helpText": "Sett dato for søknadsfristen.",
  "delivery.deadline.required": "Vennligst angi dato",
  "delivery.userFee.label": "Er det krav til brukerbetaling for å motta tjenesten?",
  "delivery.userFee.help": "Er det krav til brukerbetaling for å motta tjenesten? Dersom ja, bruk kommentarfeltet for videre forklaring eller presisering.",
  "delivery.userFee.comment.label": "Har du en kommentar til brukerbetaling?",
  "delivery.userFee.required": "Vennligst velg et alternativ",
  "delivery.userFeeComments.required": "Vennligst legg til kommentar",

  "contact.title": "Kontaktinfo og leverandør",
  "contact.name.label": "Navn",
  "contact.name.help": "Din informasjon settes automatisk, men du kan endre hvem som er kontaktperson for tjenesten.",
  "contact.name.required": "Vennligst fyll inn navn på kontaktperson",
  "contact.email.label": "E-postadresse",
  "contact.email.required": "Vennligst fyll inn e-postadresse",
  "contact.phone.label": "Telefonnummer",
  "contact.phone.required": "Vennligst fyll inn telefonnummer",
  "contact.phone.maxLength": "Telefonnummer kan maksimalt være 15 tegn",
  "contact.supplier.question": "Hvem leverer tjenesten?",
  "contact.supplier.info": "Leverandørfeltet fylles ut automatisk fra profilinformasjonen.",
  "contact.client.question": "Hvem er oppdragsgiver?",
  "contact.client.info": "Leverandørfeltet fylles ut automatisk fra profilinformasjonen.",
  "contact.client.placeholder": "Vennligst legg til oppdragsgiver",
  "contact.client.dialogTitle": "Legg til oppdragsgiver",
  "contact.client.required": "Vennligst legg til minst én oppdragsgiver",

  "eea.title": "EØS-artikler",
  "eea.applies.label": "Anvender tjenesten EØS-artikler?",
  "eea.applies.help": "Svar nei hvis tjenesten ikke anvender EØS-artikler.",
  "eea.articles.question": "Hvilke EØS-artikler anvendes?",
  "eea.articles.help": "Velg en eller flere EØS-artikler fra listen for å angi hvilke som anvendes.",
  "eea.articles.placeholder": "Vennligst legg til anvendte artikler",
  "eea.articles.dialogTitle": "Legg til EØS-artikler",
  "eea.comments.label": "Har du kommentarer til EØS-artiklene?",
  "eea.comments.help": "Utdyp her ved presisering.",
  "eea.comments.outsideLabel": "Har du kommentarer til hvorfor tjenesten faller utenfor EØS-regelverket?",
  "eea.comments.outsideHelp": "Utdyp hvorfor tjenesten faller utenfor EØS-regelverket.",
  "eea.comments.maxLength": "Maksimalt 500 tegn",

  "summary.title": "Oppsummering",
  "summary.inactiveWarning.title": "For at tjenesten skal få status \"Aktiv\" må du endre følgende:",
  "summary.inactiveWarning.validFrom": "må være i dag eller tidligere enn dagens dato",
  "summary.inactiveWarning.validTo": "må være i dag eller etter dagens dato",

  "errors.fillRequired": "Vennligst fyll ut alle påkrevde felt",
  "errors.nameRequired": "Vennligst skriv navnet på tjenesten",

  "toasts.created": "Tjenesten er opprettet",
  "toasts.published": "Tjenesten er publisert",
  "toasts.draftSaved": "Utkastet er lagret",
  "toasts.draftDeleted": "Utkastet er slettet",
  "toasts.error": "Noe gikk galt",

  "missingServices": "Du mangler tjenester",
  "missingServicesText": "Rediger tjenestene dine, slik at andre kan henvise til de",

  "templates.info": "Du kan velge en mal i listen under, eller bruke et tomt skjema.",
  "templates.useTemplate": "Bruk mal",
  "templates.emptyForm": "Bruk tomt skjema",

  "purpose": "Formål"
}
